<br>
<h1>About this Website</h1>

<p>Creator : Thawin Chalermdit</p>
<p>Inspiration : SafeTIST Farm, Thailand</p>

<img src="images/Me.jpg" alt="">
<h1>Tools</h1>
<p>-Visual Studio Code</p>
<p>-Svelte JS https://svelte.dev/</p>

<img src="images/Svelte.png" alt="">
